module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/justyna-kubiak-370735e2fcb312d2786a9d9ae0fd1e2b.webp";